import moment from 'moment';
var PREVIEW_DATE = moment(new Date()).format('D MMMM YYYY');
var DEFAULT_SHARE_HELP = 'By defining the sharing options data above, you are taking the first step in ensuring consistent viral messaging across your marketing campaign and social networks. You can tailor sharing on individual networks by ticking the options below. This will give you more control of what your fans see and share across different networks. We will automatically add a referral tracking parameter to your link e.g. r=abc123'; // TODO: preview may need more fields to adequately format each preview

var PREVIEW_CONFIG = {
  "default": {
    avatar: 'avatars/default-avatar-tiny.png',
    userName: 'Biggest Fan',
    handle: ''
  },
  facebookShare: {
    avatar: 'avatars/facebook-avatar-tiny.png',
    userName: 'Number one fan',
    handle: '1 minute ago via Your App Name'
  },
  facebookConfirmation: {
    avatar: 'avatars/facebook-avatar-tiny.png',
    userName: 'Number one fan',
    handle: '1 minute ago via Your App Name'
  },
  twitterShare: {
    avatar: 'avatars/twitter-avatar-tiny.png',
    userName: 'X User',
    handle: '@XUser'
  },
  whatsappShare: {
    userName: 'A WhatsApp User',
    handle: ''
  },
  vkShare: {
    avatar: 'avatars/default-avatar-tiny.png',
    userName: 'Biggest Fan',
    handle: ''
  },
  weiboShare: {
    avatar: 'avatars/default-avatar-tiny.png',
    userName: 'A Weibo User',
    handle: '@AWeiboUser'
  },
  pinterestShare: {
    avatar: 'avatars/default-avatar-tiny.png',
    userName: 'Biggest Fan',
    handle: 'Board Name'
  },
  googleShare: {
    avatar: 'avatars/default-avatar-tiny.png',
    userName: 'Number one fan',
    handle: ''
  }
};
var SharingConstants = {
  PREVIEW_DATE: PREVIEW_DATE,
  PREVIEW_CONFIG: PREVIEW_CONFIG,
  DEFAULT_SHARE_HELP: DEFAULT_SHARE_HELP
};
export default SharingConstants;
//# sourceMappingURL=constants.js.map